<template>
  <div>
    <div class="setUp"
         v-loading="loading">
      <div class="title"
           v-if="!showMail">{{$t('setting.phone_set')}}</div>
      <div class="title"
           v-if="showMail">{{$t('setting.mail_set')}}</div>
      <!-- <el-radio-group v-model="radio"
                      v-if="showMail"
                      style="margin-bottom: 10px"
                      size="small">
        <el-radio-button label="phone">手机</el-radio-button>
        <el-radio-button label="mail">邮箱</el-radio-button>
      </el-radio-group> -->
      <template v-if="radio == 'phone'">
        <div class="text">{{$t('setting.primary_number')}}：<span class="phone">{{mainPhone}}</span>{{$t('setting.note')}}：<span v-if="!showMainPhoneNoteInput">{{main_name}}</span>
          <i class="el-icon-edit-outline"
             v-if="!showMainPhoneNoteInput"
             style="margin:0 6px;"
             @click="phoneNoteEdit('main',{mainPhone:mainPhone})"></i>
          <el-input v-if="showMainPhoneNoteInput"
                    v-model="mainPhoneNote"
                    size="mini"
                    :placeholder="$t('setting.phone_placeholder')"
                    style="width:100px;margin:0 6px;"></el-input>
          <i class="el-icon-check"
             v-if="showMainPhoneNoteInput"
             @click="phoneNoteSub({name:mainPhoneNote,phone_id:main_phone_id})"></i>
          <i class="el-icon-close"
             v-if="showMainPhoneNoteInput"
             @click="showMainPhoneNoteInput = false"></i>
        </div>
        <div class="text">{{$t('setting.second_number')}} ：
          <div class="assistPhoneList-area">
            <div v-for="(item,index) in assistPhoneList"
                 :key="item.phone_id"
                 class="assistPhoneList">
              <span class="phone">{{item.phone}}</span> {{$t('setting.note')}}：<span v-if="!assistPhoneNoteArr.includes(item.phone_id)">{{item.name}}</span>
              <i class="el-icon-edit-outline"
                 v-if="!assistPhoneNoteArr.includes(item.phone_id)"
                 style="margin:0 6px;"
                 @click="phoneNoteEdit('assist',item)"></i>

              <el-input v-if="assistPhoneNoteArr.includes(item.phone_id)"
                        v-model="assistPhoneNoteList[index]"
                        size="mini"
                        :placeholder="$t('setting.phone_placeholder')"
                        style="width:100px;margin:0 6px;"></el-input>
              <i class="el-icon-check"
                 v-if="assistPhoneNoteArr.includes(item.phone_id)"
                 @click="phoneNoteSub({name:assistPhoneNoteList[index],phone_id:item.phone_id})"></i>
              <i class="el-icon-close"
                 v-if="assistPhoneNoteArr.includes(item.phone_id)"
                 @click="closeNoteEdit(item)"></i>
              <el-button class="sub"
                         type="danger"
                         size="mini"
                         @click="delPhone(item.phone_id)">{{$t('setting.delete')}}</el-button>
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="phoneNumBox">
            <el-input v-model="phoneNum"
                      size="mini"
                      onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                      :placeholder="$t('setting.phone_placeholder')"></el-input>
          </div>
          <div>
            <el-input :placeholder="$t('setting.optional')"
                      v-model="addPhoneNote"
                      size="mini"
                      style="width: 120px;margin-right: 10px"></el-input>
          </div>
          <div>
            <el-checkbox v-model="checked"
                         @change="isChecked">{{$t('setting.sms')}}</el-checkbox>
            <el-button class="sub"
                       type="primary"
                       size="mini"
                       @click="addPhone">{{$t('setting.add')}}</el-button>
          </div>
        </div>
        <div class="desc-area">
          <div>
            <span>{{$t('setting.desc')}}</span>
          </div>
          <div>
            <span>
              {{$t('setting.example')}}
            </span>
          </div>
        </div>
      </template>
      <template v-else-if="radio == 'mail'">
        <div class="text">{{$t('setting.mail_number')}} ：
          <div class="assistPhoneList-area">
            <div v-for="(item) in mailList"
                 :key="item.mail_id"
                 class="assistPhoneList">
              <span class="mail">{{item.mail}}</span>
              <el-button class="sub"
                         type="danger"
                         size="mini"
                         @click="delMail(item.mail_id)">{{$t('setting.delete')}}</el-button>
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="phoneNumBox">
            <el-input v-model="mailNum"
                      :placeholder="$t('setting.phone_placeholder')"></el-input>
          </div>
          <div>
            <!-- <el-checkbox v-model="checked"
                         @change="isChecked"></el-checkbox> -->
            <el-button class="sub"
                       type="primary"
                       size="mini"
                       @click="addMailFuc">{{$t('setting.add_mail')}}</el-button>
          </div>
        </div>
      </template>
    </div>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :append-to-body="true"
               :show-close="false"
               :visible="centerDialogVisible"
               width="288px"
               custom-class="successBox"
               center>
      <div style="text-align:center;">{{$t('setting.success')}}</div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="refresh">{{$t('setting.confirm')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible="phoneDialogVisible"
               width="288px"
               custom-class="phoneDialog"
               center>
      <div style="padding-left:24px;">{{$t('setting.dialog_phone')}}： {{mainPhone}}</div>
      <div class="codeBox">
        <div>
          <el-input class="code_input"
                    size="mini"
                    type="text"
                    v-model="code"
                    :placeholder="$t('setting.dialog_input_placeholder')"></el-input>
        </div>
        <el-button type="text"
                   :disabled="codeDisabled"
                   size="mini"
                   @click="getSmsCode">{{codeMsg}}</el-button>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="verification">{{$t('setting.verification')}}</el-button>
        <el-button size="mini"
                   @click="phoneDialogVisible = false">{{$t('setting.cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    getPhone: {
      type: Function,
      required: true,
    },
    setPhone: {
      type: Function,
      required: true,
    },
    setPhoneNote: {
      type: Function,
      required: true,
    },
    deletePhone: {
      type: Function,
      required: true,
    },
    deleteMail: {
      type: Function,
      required: true,
    },
    getMail: {
      type: Function,
      required: true,
    },
    addMail: {
      type: Function,
      required: true,
    },
    smsSendSetting: {
      type: Function,
      required: true,
    },
    smsVerifySetting: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      mainPhone: '',
      main_name: '', //主手机号的备注
      addPhoneNote: '',
      main_phone_id: '',
      assistPhone: '',
      assistPhoneList: [],
      assistPhoneNoteList: [],
      assistPhoneNoteArr: [],
      phoneNum: '',
      checked: true,
      centerDialogVisible: false,
      code: '',
      phone_id: '',
      phoneDialogVisible: false,
      codeDisabled: false,
      countdown: 60,
      codeMsg: '获取验证码',
      timer: null,
      mainPhoneNote: '',
      showMainPhoneNoteInput: false,
      // 邮箱
      radio: 'phone',
      mailList: [],
      mailNum: '',
      showMail: false,
    }
  },
  computed: {
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
  },
  methods: {
    isChecked(val) {
      if (this.mainPhone == '') {
        this.checked = true
        this.$message.error(this.$t('setting.first_num'))
        return false
      }
    },
    addPhone() {
      if (this.phoneNum == '') {
        this.$message.error(this.$t('setting.enter_num'))
        return
      }
      //   if (!/^1[0-9]{10}$/.test(this.phoneNum)) {
      //     this.$message.error('请输入正确的手机号')
      //     return
      //   }
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting || this.mainPhone == '') {
        this.subPhone()
      } else {
        this.phoneDialogVisible = true
      }
    },
    addMailFuc() {
      if (this.mailNum == '') {
        this.$message.error(this.$t('setting.enter_mail'))
        return
      }
      if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(this.mailNum)) {
        this.$message.error(this.$t('setting.enter_correct_mail'))
        return
      }
      this.addMail({
        mail: this.mailNum,
      }).then((res) => {
        if (res.status == 'ok') {
          this.$message.success('修改成功')
          this.getPhoneData()
        } else {
          this.$message.error(res.error_msg)
        }
      })
    },
    getPhoneData() {
      this.loading = true
      this.getMail()
        .then((res) => {
          this.loading = false
          const result = res.result
          const phone = result.phone
          const mail = result.mail
          if (phone && phone.length > 0) {
            let obj = phone.find((item) => {
              return item.main == true
            })
            this.mainPhone = obj.phone
            this.main_phone_id = obj.phone_id
            this.main_name = obj.name
            let arr = phone.filter((item) => {
              return item.main != true
            })
            this.assistPhoneList = arr
            for (let i = 0; i < arr.length; i++) {
              this.assistPhoneNoteList.push(arr[i].name)
            }
          }
          if (mail && mail.length > 0) {
            this.mailList = mail
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
          this.loading = false
        })
    },
    subPhone() {
      this.setPhone({
        phone: this.phoneNum,
        name: this.addPhoneNote,
        is_login_verify: this.checked + '',
        site_lang: this.$i18n.locale,
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (this.mainPhone != '') {
              //   this.assistPhoneList.push({
              //     phone: this.phoneNum,
              //     name: this.addPhoneNote,
              //     phone_id: res.result.phone_id,
              //   })
              this.getPhoneData()
            }
            this.centerDialogVisible = true
          } else {
            this.$message.error(res.error_msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
        })
    },
    delPhone(phone_id) {
      this.phone_id = phone_id
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting) {
        this.$confirm('确认删除?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
        })
          .then(() => {
            this.deletePhone({
              phone_id: phone_id,
            })
              .then((res) => {
                if (res.status == 'ok') {
                  this.assistPhoneList = this.assistPhoneList.filter((item) => {
                    return !phone_id.includes(item.phone_id)
                  })
                  this.$message.success('删除成功')
                } else {
                  this.$message.error(res.error_msg)
                }
              })
              .catch((e) => {
                this.$message.error(e.data.error_msg)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      } else {
        this.phoneDialogVisible = true
      }
    },
    delMail(mail_id) {
      this.mail_id = mail_id
      this.$confirm('确认删除?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
      })
        .then(() => {
          this.deleteMail({
            mail_id: mail_id,
          })
            .then((res) => {
              if (res.status == 'ok') {
                this.mailList = this.mailList.filter((item) => {
                  return !mail_id.includes(item.mail_id)
                })
                this.$message.success('删除成功')
              } else {
                this.$message.error(res.error_msg)
              }
            })
            .catch((e) => {
              this.$message.error(e.data.error_msg)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    getSmsCode() {
      if (!this.codeDisabled) {
        this.codeDisabled = true
        this.smsSendSetting({ phone_id: this.main_phone_id })
          .then((res) => {
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr()
              this.timer = setInterval(this.getValidStr, 1000)
            }
            if (res.status == 'ok') {
            } else {
              this.$message.warning(res.error_msg)
            }
          })
          .catch((e) => {
            this.codeDisabled = false
          })
          .finally(() => {})
      }
    },
    getValidStr() {
      if (this.countdown > 0 && this.countdown <= 60) {
        this.countdown--
        if (this.countdown !== 0) {
          this.codeMsg = this.countdown + 's'
        } else {
          clearInterval(this.timer)
          this.codeMsg = '获取验证码'
          this.countdown = 60
          this.timer = null
          this.codeDisabled = false
        }
      }
    },
    verification() {
      if (this.code == '') {
        this.$message.warning('请输入验证码')
        return
      }
      this.smsVerifySetting({ code: this.code, phone_id: this.main_phone_id })
        .then((res) => {
          if (res.status == 'ok') {
            this.phoneDialogVisible = false
            sessionStorage.setItem('hasVerifySetting', true)
            // location.reload()
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg || '验证失败')
        })
    },
    refresh() {
      this.centerDialogVisible = false
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (!hasVerifySetting) {
        location.reload()
      }
    },
    phoneNoteEdit(typ, val) {
      // eslint-disable-next-line no-console
      console.log(typ, val)
      let hasVerifySetting = sessionStorage.getItem('hasVerifySetting')
      if (hasVerifySetting) {
        if (typ == 'main') {
          this.mainPhoneNote = this.main_name
          this.showMainPhoneNoteInput = true
        } else if (typ == 'assist') {
          if (!this.assistPhoneNoteArr.includes(val.phone_id)) {
            this.assistPhoneNoteArr.push(val.phone_id)
          }
          const index = _.findIndex(this.assistPhoneList, function (o) {
            return o.phone_id == val.phone_id
          })
          if (index !== -1) {
            this.assistPhoneNoteList.splice(index, 1, val.name)
          }
        }
      } else {
        this.phoneDialogVisible = true
      }
    },
    phoneNoteSub(val) {
      this.setPhoneNote({
        name: val.name,
        phone_id: val.phone_id,
        site_lang: this.$i18n.locale,
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (val.phone_id == this.main_phone_id) {
              this.showMainPhoneNoteInput = false
            } else {
              const index = this.assistPhoneNoteArr.indexOf(val.phone_id)
              if (index !== -1) {
                this.assistPhoneNoteArr.splice(index, 1)
              }
            }
            this.getPhoneData()
          } else {
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg)
        })
    },
    closeNoteEdit(val) {
      const index = this.assistPhoneNoteArr.indexOf(val.phone_id)
      if (index !== -1) {
        this.assistPhoneNoteArr.splice(index, 1)
      }
    },
  },
  created() {
    this.getPhoneData()
  },
  watch: {
    loginInfo: {
      handler(newVal) {
        if (newVal && newVal.use_mail) {
          if (newVal.use_mail) {
            this.radio = 'mail'
            this.showMail = true
          } else {
            this.radio = 'phone'
            this.showMail = false
          }
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scoped lang='less'>
.views {
  /deep/ .phoneDialog {
    .codeBox {
      display: flex;
      margin-top: 10px;
      padding: 0 24px;
      .code_input {
        margin-right: 12px;
      }
    }
    .el-input__inner {
      width: 128px !important;
      height: 28px !important;
      border: 1px solid #ccc !important;
    }
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 24px 0 20px !important;
    }
    .el-dialog__footer {
      padding-bottom: 24px;
    }
  }
  /deep/ .successBox {
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 24px 0 55px !important;
    }
    .el-dialog__footer {
      padding-bottom: 24px;
    }
  }
}
.setUp {
  padding: 48px;
  width: 100%;
  height: 350px;
  // padding: 0 0 !important;
  box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
  border-radius: 4px 4px 4px 4px;
  background-color: white;
  font-family: MicrosoftYaHei;
  color: #252525;
  .assistPhoneList-area {
    max-height: 80px;
    overflow-y: auto;
    width: 500px;
    .assistPhoneList {
      margin-bottom: 10px;
    }
  }
  .title {
    font-size: 16px;
    margin-bottom: 22px;
  }
  .text {
    font-size: 14px;
    margin-bottom: 12px;
    .phone {
      margin: 0 16px;
      vertical-align: middle;
    }
  }
  .inputBox {
    margin-top: 10px;
    display: flex;
    .phoneNumBox {
      margin-right: 18px;
      /deep/ input {
        width: 170px;
        height: 28px;
      }
    }
  }
  .desc-area {
    margin-top: 10px;
    color: #85868a;
    font-size: 12px;
  }
  .sub {
    margin-left: 28px;
  }
}
</style>